import { device } from "@/style/constants";
import { pxToRem } from "@/style/utils";
import { Button } from "@riot-private/ux-react-components";
import styled from "styled-components";

export const S_ListingModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  color: ${({ theme }) => theme.colors["gray.99"]};
  background: ${({ theme }) => theme.colors["gray.16"]};

  @media ${device.laptop} {
    color: ${({ theme }) => theme.colors["gray.04"]};
    background: ${({ theme }) => theme.colors["gray.99"]};
  }
`;

export const S_ListingBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    path {
      fill: ${({ theme }) => theme.colors["gray.99"]};

      @media ${device.laptop} {
        fill: ${({ theme }) => theme.colors["gray.12"]};
      }
    }
  }
`;

export const S_CloseButton = styled(Button.Secondary)`
  align-self: flex-end;

  background-color: ${({ theme }) => theme.colors["gray.50-alpha.20"]};
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  margin: ${pxToRem(16)};
  z-index: 10;

  .label {
    transform: rotate(45deg);
    font-size: ${pxToRem(16)};
  }
`;

export const S_ModalTitle = styled.div`
  font-size: ${pxToRem(32)};
  font-weight: bold;
  margin: 2rem 3rem;

  @media ${device.laptop} {
    margin-top: 0;
  }
`;

export const S_ProductListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 3rem;
`;
export const S_ProductContainer = styled.div`
  font-size: ${pxToRem(14)};
  display: flex;
  justify-content: space-between;
  text-align: left;
`;

export const S_ProductPriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(4)};
`;

export const S_ProductFinalPrice = styled.span`
  &.final-price {
    &--discounted {
      color: ${({ theme }) => theme.colors["gray.68"]};

      @media ${device.laptop} {
        color: ${({ theme }) => theme.colors["gray.39"]};
      }
      text-decoration: line-through;
    }
  }
`;

export const S_GrouperPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(4)};
  margin: 1rem;
  padding-top: 1rem;
  /* twice the listing padding */
  width: calc(100% - 6rem);
  border-top: 1px solid ${({ theme }) => theme.colors["gray.50-alpha.20"]};
`;

export const S_ActionsContainer = styled.div`
  background: ${({ theme }) => theme.colors["gray.12"]};
  @media ${device.laptop} {
    background: ${({ theme }) => theme.colors["gray.96"]};
  }
`;

export const S_GrouperBuy = styled(Button.Primary)`
  margin: 1.5rem 3rem;
  width: calc(100% - 6rem);
  height: fit-content;

  .label {
    margin: 0.5rem;
  }
`;
